// @flow

import React from 'react';
import { timeout } from 'promise-timeout';
import loadable from '@loadable/component';
import { IsomorphicRipple } from 'shared_components/common/preloader/IsomorphicRipple';

const LOADABLE_TIMEOUT = 10000;
const FallbackComponent = (
  <IsomorphicRipple isFullScreen isActive customStyles={{ backgroundColor: '#ffffff' }} />
);

/**
 * CMS_LAYOUT_COMPONENTS
 *
 * Lazyloaded layout components. The key of this object is same as the layout key from API CMS layout response
 */
export const CMS_LAYOUT_COMPONENTS: Object = {
  'cms-default': loadable(
    () => timeout(import('shared_components/cms/layouts/Default'), LOADABLE_TIMEOUT),
    {
      resolveComponent: (components) => components.CmsLayoutDefault,
      fallback: FallbackComponent,
    },
  ),
  'cms-sections': loadable(
    () => timeout(import('shared_components/cms/layouts/Sections'), LOADABLE_TIMEOUT),
    {
      resolveComponent: (components) => components.CmsLayoutSections,
      fallback: FallbackComponent,
    },
  ),
  'cms-sidebar-left': loadable(
    () => timeout(import('shared_components/cms/layouts/SidebarLeft'), LOADABLE_TIMEOUT),
    {
      resolveComponent: (components) => components.CmsLayoutSidebarLeft,
      fallback: FallbackComponent,
    },
  ),
  'cms-responsive': loadable(
    () => timeout(import('shared_components/cms/layouts/Responsive'), LOADABLE_TIMEOUT),
    {
      resolveComponent: (components) => components.CmsLayoutResponsive,
      fallback: FallbackComponent,
    },
  ),
};
